// Auto-generated by scripts/sync.js on 2026-02-23
// Run "npm run sync" to regenerate from LeetCodeExercises

export const problems = [

  // ── EASY ──────────────────────────────────────────────────────────────────
  {
    id: 'apply-transform-over-each-element-in-array',
    title: 'Apply Transform Over Each Element in Array',
    difficulty: 'Easy',
    topics: ["Array"],
    language: 'JavaScript',
    description: 'Apply a given function to each element in an array.',
    leetcodeUrl: 'https://leetcode.com/problems/apply-transform-over-each-element-in-array/',
    solution: `/**
 * @param {number[]} arr
 * @param {Function} fn
 * @return {number[]}
 */
var map = function(arr, fn) {
    const res = [];
    for (let i = 0; i<arr.length; i++) {
        res.push(fn(arr[i], i));
    }
    return res;
};`,
    fullDescription: `## Description

Given an integer array \`arr\` and a mapping function \`fn\`, return a new array with a transformation applied to each element.

The returned array should be created such that \`returnedArray[i] = fn(arr[i], i)\`.

Please solve it without the built-in \`Array.map\` method.

---

## Constraints

- \`0 <= arr.length <= 1000\`  
- \`-10⁹ <= arr[i] <= 10⁹\`  
- \`fn\` returns an integer.`,
  },
  {
    id: 'can-place-flowers',
    title: 'Can Place Flowers',
    difficulty: 'Easy',
    topics: ["Array","Greedy"],
    language: 'JavaScript',
    description: 'Determine if flowers can be planted without violating the no-adjacent rule.',
    leetcodeUrl: 'https://leetcode.com/problems/can-place-flowers/',
    solution: `/**
 * @param {number[]} flowerbed
 * @param {number} n
 * @return {boolean}
 */
var canPlaceFlowers = function(flowerbed, n) {
    let counter = 0;
    if (flowerbed.length === 1) {
        if (flowerbed[0] === 0) {
            counter++;
        }
        return counter >= n
    }
    for (let i = 0; i < flowerbed.length; i++) {
        if (i === 0) {
            if (flowerbed[i] === 0 && flowerbed[1] === 0) {
                flowerbed[i] = 1
                counter++;
            }
        } else if (i === flowerbed.length - 1) {
            if (flowerbed[i] === 0 && flowerbed[flowerbed.length-2] === 0) {
                flowerbed[i] = 1
                counter++;
            }
        } else if (flowerbed[i] === 0 && flowerbed[i-1] === 0 && flowerbed[i+1] === 0) {
            flowerbed[i] = 1;
            counter++;
        }
        if (counter >= n) {
            return true;
        }
    }
    return counter >= n
};`,
    fullDescription: `## Description

You have a long flowerbed in which some of the plots are planted, and some are not. However, flowers cannot be planted in adjacent plots.

Given an integer array \`flowerbed\` containing \`0\`s and \`1\`s, where \`0\` means empty and \`1\` means not empty, and an integer \`n\`, return \`true\` if \`n\` new flowers can be planted in the flowerbed without violating the no-adjacent-flowers rule and \`false\` otherwise.

---

## Constraints

- \`1 <= flowerbed.length <= 2 * 10⁴\`  
- \`flowerbed[i]\` is \`0\` or \`1\`  
- There are no two adjacent flowers in \`flowerbed\`  
- \`0 <= n <= flowerbed.length\``,
  },
  {
    id: 'filter-elements-from-array',
    title: 'Filter Elements from Array',
    difficulty: 'Easy',
    topics: ["Array"],
    language: 'JavaScript',
    description: 'Remove elements from an array based on a filtering function.',
    leetcodeUrl: 'https://leetcode.com/problems/filter-elements-from-array/',
    solution: `/**
 * @param {number[]} arr
 * @param {Function} fn
 * @return {number[]}
 */
var filter = function(arr, fn) {
    const result = [];
    for (let i = 0; i < arr.length; i++) {
        if (fn(arr[i], i)) {
            result.push(arr[i]);
        }
    }
    return result
};`,
    fullDescription: `## Description
Given an integer array \`arr\` and a filtering function \`fn\`, return a filtered array \`filteredArr\`.

The \`fn\` function takes one or two arguments:
- \`arr[i]\`: the number from the array
- \`i\`: the index of \`arr[i]\`

The \`filteredArr\` should only contain the elements from \`arr\` for which the expression \`fn(arr[i], i)\` evaluates to a **truthy** value.

A **truthy** value is a value where \`Boolean(value)\` returns \`true\`.

> ⚠️ You must solve this without using the built-in \`Array.filter\` method.

---

## Constraints

- \`0 <= arr.length <= 1000\`  
- \`-10⁹ <= arr[i] <= 10⁹\``,
  },
  {
    id: 'find-pivot-index',
    title: 'Find Pivot Index',
    difficulty: 'Easy',
    topics: ["Array","Prefix Sum"],
    language: 'JavaScript',
    description: 'Find the index where the sum on the left equals the sum on the right.',
    leetcodeUrl: 'https://leetcode.com/problems/find-pivot-index/',
    solution: `/**
 * @param {number[]} nums
 * @return {number}
 */
var pivotIndex = function(nums) {
    let total = nums.reduce((a, b) => a + b, 0);
    let leftSum = 0;
    for (let i = 0; i < nums.length; i++) {
        if (leftSum === (total - leftSum - nums[i])) {
            return i;
        }
        leftSum += nums[i];
    }
    return -1;
};`,
    fullDescription: `## Description

Given an array of integers \`nums\`, calculate the pivot index of this array.

The pivot index is the index where the sum of all the numbers strictly to the left of the index is equal to the sum of all the numbers strictly to the index's right.

If the index is on the left edge of the array, then the left sum is 0 because there are no elements to the left. This also applies to the right edge of the array.

Return the leftmost pivot index. If no such index exists, return \`-1\`.

---

## Constraints

- \`1 <= nums.length <= 10⁴\`  
- \`-1000 <= nums[i] <= 1000\``,
  },
  {
    id: 'find-the-highest-altitude',
    title: 'Find the Highest Altitude',
    difficulty: 'Easy',
    topics: ["Array","Prefix Sum"],
    language: 'JavaScript',
    description: 'Find the highest altitude reached given gain values.',
    leetcodeUrl: 'https://leetcode.com/problems/find-the-highest-altitude/',
    solution: `/**
 * @param {number[]} gain
 * @return {number}
 */
var largestAltitude = function(gain) {
    let highest = 0;
    let sum = 0;
    for (let i = 0; i<gain.length; i++) {
        sum = sum + gain[i];
        if (sum > highest) {
            highest = sum;
        }
    }
    return highest;
};`,
    fullDescription: `## Description

There is a biker going on a road trip. The road trip consists of \`n + 1\` points at different altitudes. The biker starts his trip at point \`0\` with altitude equal to \`0\`.

You are given an integer array \`gain\` of length \`n\` where \`gain[i]\` is the net gain in altitude between points \`i\` and \`i + 1\` for all \`0 <= i < n\`.

Return the highest altitude of any point during the trip.

---

## Constraints

- \`n == gain.length\`  
- \`1 <= n <= 100\`  
- \`-100 <= gain[i] <= 100\``,
  },
  {
    id: 'guess-number-higher-or-lower',
    title: 'Guess Number Higher or Lower',
    difficulty: 'Easy',
    topics: ["Binary Search"],
    language: 'JavaScript',
    description: 'Guess the number using binary search strategy.',
    leetcodeUrl: 'https://leetcode.com/problems/guess-number-higher-or-lower/',
    solution: `/** 
 * Forward declaration of guess API.
 * @param {number} num   your guess
 * @return 	     -1 if num is higher than the picked number
 *			      1 if num is lower than the picked number
 *               otherwise return 0
 * var guess = function(num) {}
 */

/**
 * @param {number} n
 * @return {number}
 */
var guessNumber = function(n) {
    let low = 1;
    let high = n;
    let currentGuess, mid;
    do {
        mid = (low+high)/2;
        currentGuess = guess(mid);
        if (currentGuess == -1) {
            high = mid - 1;
        }
        if (currentGuess == 1) {
            low = mid + 1;
        }
    } while (currentGuess != 0) 
    return mid;
};`,
    fullDescription: `## Description

You are playing a game with your friend where you try to guess a number they picked between \`1\` and \`n\`.  
Every time you guess wrong, they will tell you whether the number is higher or lower than your guess.  
You call a predefined API \`int guess(int num)\` which returns:
- \`-1\` if the number is lower than the picked number
- \`1\` if the number is higher than the picked number
- \`0\` if your guess is correct

Return the number your friend picked.

## Constraints

- \`1 <= n <= 2^31 - 1\`
- The picked number is in the range \`[1, n]\``,
  },
  {
    id: 'is-subsequence',
    title: 'Is Subsequence',
    difficulty: 'Easy',
    topics: ["Two Pointers","String"],
    language: 'JavaScript',
    description: 'Check if one string is a subsequence of another.',
    leetcodeUrl: 'https://leetcode.com/problems/is-subsequence/',
    solution: `/**
 * @param {string} s
 * @param {string} t
 * @return {boolean}
 */
var isSubsequence = function(s, t) {
    if (!s) {
        return true;
    }
    if (s.length > t.length) {
        return false;
    }
    for (let i=0, k=0; i<t.length; i++) {
        if (t[i] === s[k]) {
            k++;
            if (k === s.length) {
                return true
            }
        }
    }
    return false;
};`,
    fullDescription: `## Description

Given two strings \`s\` and \`t\`, return \`true\` if \`s\` is a subsequence of \`t\`, or \`false\` otherwise.

A subsequence of a string is a new string that is formed from the original string by deleting some (can be none) of the characters without disturbing the relative positions of the remaining characters.  
(i.e., \`"ace"\` is a subsequence of \`"abcde"\` while \`"aec"\` is not).

---

## Constraints

- \`0 <= s.length <= 100\`  
- \`0 <= t.length <= 10⁴\`  
- \`s\` and \`t\` consist only of lowercase English letters.

---

## Follow-up

Suppose there are lots of incoming \`s\`, say \`s₁\`, \`s₂\`, ..., \`sₖ\` where \`k >= 10⁹\`, and you want to check one by one to see if \`t\` has its subsequence.  
In this scenario, how would you change your code?`,
  },
  {
    id: 'kids-with-the-greatest-number-of-candies',
    title: 'Kids With the Greatest Number of Candies',
    difficulty: 'Easy',
    topics: ["Array"],
    language: 'JavaScript',
    description: 'Determine which kids can have the greatest number of candies.',
    leetcodeUrl: 'https://leetcode.com/problems/kids-with-the-greatest-number-of-candies/',
    solution: `/**
 * @param {number[]} candies
 * @param {number} extraCandies
 * @return {boolean[]}
 */
var kidsWithCandies = function(candies, extraCandies) {
    const max = Math.max(...candies);
    return candies.map(kidC => (kidC + extraCandies) >= max)
};`,
    fullDescription: `## Description

There are \`n\` kids with candies. You are given an integer array \`candies\`, where each \`candies[i]\` represents the number of candies the \`i\`th kid has, and an integer \`extraCandies\`, denoting the number of extra candies that you have.

Return a boolean array \`result\` of length \`n\`, where \`result[i]\` is \`true\` if, after giving the \`i\`th kid all the \`extraCandies\`, they will have the greatest number of candies among all the kids, or \`false\` otherwise.

Note that multiple kids can have the greatest number of candies.

---

## Constraints

- \`n == candies.length\`  
- \`2 <= n <= 100\`  
- \`1 <= candies[i] <= 100\`  
- \`1 <= extraCandies <= 50\``,
  },
  {
    id: 'maximum-average-subarray-i',
    title: 'Maximum Average Subarray I',
    difficulty: 'Easy',
    topics: ["Array","Sliding Window"],
    language: 'JavaScript',
    description: 'Find the maximum average of a subarray of length k.',
    leetcodeUrl: 'https://leetcode.com/problems/maximum-average-subarray-i/',
    solution: `/**
 * @param {number[]} nums
 * @param {number} k
 * @return {number}
 */
var findMaxAverage = function(nums, k) {
    let max = 0;
    for (let i = 0; i < k; i++) {
        max = max + nums[i];
    }

    let slidingSum = max;
    for (let i = k; i<nums.length; i++) {
        slidingSum = slidingSum + nums[i] - nums[i-k];
        if (slidingSum > max) {
            max = slidingSum;
        }
    }

    return max/k;
};`,
    fullDescription: `## Description

You are given an integer array \`nums\` consisting of \`n\` elements, and an integer \`k\`.  
Find a contiguous subarray whose length is equal to \`k\` that has the maximum average value and return this value.

Any answer with a calculation error less than \`10⁻⁵\` will be accepted.

---

## Constraints

- \`n == nums.length\`  
- \`1 <= k <= n <= 10⁵\`  
- \`-10⁴ <= nums[i] <= 10⁴\``,
  },
  {
    id: 'maximum-depth-of-binary-tree',
    title: 'Maximum Depth of Binary Tree',
    difficulty: 'Easy',
    topics: ["Tree","DFS","BFS"],
    language: 'Java',
    description: 'Compute the maximum depth of a binary tree.',
    leetcodeUrl: 'https://leetcode.com/problems/maximum-depth-of-binary-tree/',
    solution: `/**
 * Definition for a binary tree node.
 * public class TreeNode {
 *     int val;
 *     TreeNode left;
 *     TreeNode right;
 *     TreeNode() {}
 *     TreeNode(int val) { this.val = val; }
 *     TreeNode(int val, TreeNode left, TreeNode right) {
 *         this.val = val;
 *         this.left = left;
 *         this.right = right;
 *     }
 * }
 */
class Solution {
    private int max = 1;
    public int maxDepth(TreeNode root) {
        if (root == null) {
            return 0;
        }

        maxDepth(root, 1);
        return max;
    }

     public TreeNode maxDepth(TreeNode root, int i) {
        if (root != null && (root.left != null || root.right != null)) {
            TreeNode left = maxDepth(root.left, i+1);
            TreeNode rigth = maxDepth(root.right, i+1);
        }
        if (i > max) {
            max = i;
        }
        return null;
    }
}`,
    fullDescription: `## Description

Given the \`root\` of a binary tree, return its maximum depth.

A binary tree's maximum depth is the number of nodes along the longest path from the root node down to the farthest leaf node.

---

## Constraints

- The number of nodes in the tree is in the range \`[0, 10⁴]\`  
- \`-100 <= Node.val <= 100\``,
  },
  {
    id: 'n-th-tribonacci-number',
    title: 'N-th Tribonacci Number',
    difficulty: 'Easy',
    topics: ["Dynamic Programming"],
    language: 'JavaScript',
    description: 'Return the n-th number in the Tribonacci sequence.',
    leetcodeUrl: 'https://leetcode.com/problems/n-th-tribonacci-number/',
    solution: `/**
 * @param {number} n
 * @return {number}
 */
var tribonacci = function(n) {
    if (n===0) {
        return 0;
    }
    let arr = [0, 1, 1];
    for (let i = 3; i<=n; i++) {
        arr[i] = arr[i-3] + arr[i-2] + arr[i-1];
    }
    return arr[arr.length-1];
};`,
    fullDescription: `## Description

The Tribonacci sequence is defined as follows:

- \`T(0) = 0\`, \`T(1) = 1\`, \`T(2) = 1\`
- For \`n >= 3\`, \`T(n) = T(n-1) + T(n-2) + T(n-3)\`

Given an integer \`n\`, return the value of \`T(n)\`.

### Example

- Input: \`n = 4\` → Output: \`4\`  
  (Because \`T(4) = T(3) + T(2) + T(1) = 2 + 1 + 1 = 4\`)

## Constraints

- \`0 <= n <= 37\``,
  },
  {
    id: 'number-of-recent-calls',
    title: 'Number of Recent Calls',
    difficulty: 'Easy',
    topics: ["Design","Queue"],
    language: 'Java',
    description: 'Count recent calls within a time window.',
    leetcodeUrl: 'https://leetcode.com/problems/number-of-recent-calls/',
    solution: `class RecentCounter {
    private Queue<Integer> list;

    public RecentCounter() {
        list = new LinkedList<>();
    }

    public int ping(int t) {
        list.offer(t);
        while (t - list.peek() - 3000 > 0) {
            list.poll();
        }
        return list.size();
    }
}

/**
 * Your RecentCounter object will be instantiated and called as such:
 * RecentCounter obj = new RecentCounter();
 * int param_1 = obj.ping(t);
 */`,
    fullDescription: `## Description

You have a \`RecentCounter\` class which counts the number of recent requests within a certain time frame.

Implement the \`RecentCounter\` class:

- \`RecentCounter()\`: Initializes the counter with zero recent requests.
- \`int ping(int t)\`: Adds a new request at time \`t\` (in milliseconds), and returns the number of requests that have happened in the past 3000 milliseconds (inclusive).  
  Specifically, return the number of requests in the range \`[t - 3000, t]\`.

It is guaranteed that every call to \`ping\` uses a strictly larger value of \`t\` than the previous call.

---

## Constraints

- \`1 <= t <= 10⁹\`  
- Each test case will call \`ping\` with strictly increasing values of \`t\`  
- At most \`10⁴\` calls will be made to \`ping\``,
  },
  {
    id: 'remove-element',
    title: 'Remove Element',
    difficulty: 'Easy',
    topics: ["Array","Two Pointers"],
    language: 'JavaScript',
    description: 'Remove all instances of a given value from an array.',
    leetcodeUrl: 'https://leetcode.com/problems/remove-element/',
    solution: `/**
 * @param {number[]} nums
 * @param {number} val
 * @return {number}
 */
var removeElement = function(nums, val) {
    let size = nums.length;
    for (let i = 0; i < size; i++){
        if (nums[i] === val) {
            nums.splice(i, 1);
            size--;
            i--;
        }
    }
    return nums.length;
};`,
    fullDescription: `## Description

Given an integer array \`nums\` and an integer \`val\`, remove all occurrences of \`val\` in \`nums\` in-place. The order of the elements may be changed. Then return the number of elements in \`nums\` which are not equal to \`val\`.

Consider the number of elements in \`nums\` which are not equal to \`val\` be \`k\`, to get accepted, you need to do the following things:

- Change the array \`nums\` such that the first \`k\` elements of \`nums\` contain the elements which are not equal to \`val\`.
- The remaining elements of \`nums\` are not important as well as the size of \`nums\`.
- Return \`k\`.

Custom Judge:

The judge will test your solution with the following code:

\`\`\`
int[] nums = [...]; // Input array
int val = ...; // Value to remove
int[] expectedNums = [...]; // The expected answer with correct length.
// It is sorted with no values equaling val.
int k = removeElement(nums, val); // Calls your implementation

assert k == expectedNums.length;
sort(nums, 0, k); // Sort the first k elements of nums
for (int i = 0; i < actualLength; i++) {
    assert nums[i] == expectedNums[i];
}
\`\`\`

---

## Constraints

- 0 <= nums.length <= 100  
- 0 <= nums[i] <= 50  
- 0 <= val <= 100`,
  },
  {
    id: 'reverse-integer',
    title: 'Reverse Integer',
    difficulty: 'Easy',
    topics: ["Math"],
    language: 'JavaScript',
    description: 'Reverse digits of an integer.',
    leetcodeUrl: 'https://leetcode.com/problems/reverse-integer/',
    solution: `/**
 * @param {number} x
 * @return {number}
 */
var reverse = function(x) {
    const result = x < 0 ? parseInt("-"+(""+x).split("").slice(1).reverse().join('')) : parseInt((""+x).split("").reverse().join(''));
    if (result > 2147483647 || result < -2147483648) {
        return 0
    }
    return result
};`,
    fullDescription: `##  Description
Given a signed 32-bit integer \`x\`, return \`x\` with its digits reversed.  
If reversing \`x\` causes the value to go outside the signed 32-bit integer range \`[-2³¹, 2³¹ - 1]\`, then return \`0\`.

Assume the environment does **not** allow you to store 64-bit integers (signed or unsigned).

---

## Constraints
- \`-2³¹ <= x <= 2³¹ - 1\``,
  },
  {
    id: 'reverse-linked-list',
    title: 'Reverse Linked List',
    difficulty: 'Easy',
    topics: ["Linked List"],
    language: 'JavaScript',
    description: 'Reverse a singly linked list.',
    leetcodeUrl: 'https://leetcode.com/problems/reverse-linked-list/',
    solution: `/**
 * Definition for singly-linked list.
 * function ListNode(val, next) {
 *     this.val = (val===undefined ? 0 : val)
 *     this.next = (next===undefined ? null : next)
 * }
 */
/**
 * @param {ListNode} head
 * @return {ListNode}
 */
var reverseList = function(head) {
    let prev = null;
    let curr = head;
    if (!curr) {
        return head;
    }
    return ricorsive(prev, curr);
};

const ricorsive = function(prev, curr) {
    if (curr) {
        const next = curr.next;
        curr.next = prev;
        prev = curr;
        curr = next;
        return (ricorsive(prev, curr))
    }
    return prev;
}

/* ITERATIVE VERSION

var reverseList = function(head) {
    let prev = null;
    let curr = head;
    if (!curr) {
        return head;
    }
    while (curr) {
        const next = curr.next;
        curr.next = prev;
        prev = curr;
        curr = next;
    }
    return prev;
}; */`,
    fullDescription: `## Description

Given the head of a singly linked list, reverse the list and return the new head.

### Example

- Input: \`head = [1,2,3,4,5]\`  
  Output: \`[5,4,3,2,1]\`

## Constraints

- The number of nodes in the list is in the range \`[0, 5000]\`
- \`-5000 <= Node.val <= 5000\``,
  },
  {
    id: 'reverse-vowels-of-a-string',
    title: 'Reverse Vowels of a String',
    difficulty: 'Easy',
    topics: ["Two Pointers","String"],
    language: 'JavaScript',
    description: 'Reverse only the vowels in a string.',
    leetcodeUrl: 'https://leetcode.com/problems/reverse-vowels-of-a-string/',
    solution: `const vowels = {A: true, E: true, I: true, O: true, U: true, a: true, e: true, i: true, o: true, u: true}

/**
 * @param {string} s
 * @return {string}
 */
var reverseVowels = function(s) {
    const arr = s.split('');
    const vowelsMap = {}
    arr.forEach((l, i) => {
        if (vowels[l]) {
            vowelsMap[i] = l;
        }
    })
    const keys = Object.keys(vowelsMap);
    for (let i=0, j= keys.length - 1; i < keys.length; i++, j--) {
        arr[keys[i]] = vowelsMap[keys[j]];
    }
    return arr.join('')
};`,
    fullDescription: `## Description

Given a string \`s\`, reverse only all the vowels in the string and return it.

The vowels are \`'a'\`, \`'e'\`, \`'i'\`, \`'o'\`, and \`'u'\`, and they can appear in both lower and upper cases, more than once.

---

## Constraints

- \`1 <= s.length <= 3 * 10⁵\`  
- \`s\` consists of printable ASCII characters.`,
  },
  {
    id: 'reverse-words-of-a-string',
    title: 'Reverse Words of a String',
    difficulty: 'Easy',
    topics: ["String"],
    language: 'JavaScript',
    description: 'Reverse the order of words in a string.',
    leetcodeUrl: 'https://leetcode.com/problems/reverse-words-in-a-string/',
    solution: `/**
 * @param {string} s
 * @return {string}
 */
var reverseWords = function(s) {
    return s.split(" ").filter(a => a).reverse().join(" ");
};`,
    fullDescription: `## Description

Given an input string \`s\`, reverse the order of the words.

A word is defined as a sequence of non-space characters. The words in \`s\` will be separated by at least one space.

Return a string of the words in reverse order concatenated by a single space.

Note that \`s\` may contain leading or trailing spaces or multiple spaces between two words. The returned string should only have a single space separating the words. Do not include any extra spaces.

---

## Constraints

- \`1 <= s.length <= 10⁴\`  
- \`s\` contains English letters (upper-case and lower-case), digits, and spaces \`' '\`  
- There is at least one word in \`s\``,
  },
  {
    id: 'same-tree',
    title: 'Same Tree',
    difficulty: 'Easy',
    topics: ["Tree","DFS"],
    language: 'JavaScript',
    description: 'Check if two binary trees are identical.',
    leetcodeUrl: 'https://leetcode.com/problems/same-tree/',
    solution: `/**
 * Definition for a binary tree node.
 * function TreeNode(val, left, right) {
 *     this.val = (val===undefined ? 0 : val)
 *     this.left = (left===undefined ? null : left)
 *     this.right = (right===undefined ? null : right)
 * }
 */
/**
 * @param {TreeNode} p
 * @param {TreeNode} q
 * @return {boolean}
 */
var isSameTree = function(p, q) {
    let result = true;
    if (!p && !q) {
        return true;
    }
    if ((p && !q) || (!p && q)) {
        return false;
    }
    if (p.val !== q.val) {
        return false;
    }
    if ((p.left && !q.left) || (!p.left && q.left)) {
        return false;
    }
    if ((p.right && !q.right) || (!p.right && q.right)){
        return false;
    }
    if (p.left && q.left) {
        if (!isSameTree(p.left, q.left)) {
            return false;
        }
    }
     
    if (p.right && q.right) {
        if (!isSameTree(p.right, q.right)) {
            return false;
        }
    }
    return true;
};`,
    fullDescription: `## Description

Given two binary trees \`p\` and \`q\`, write a function to check if they are the same.  
Two binary trees are considered the same if they are structurally identical and the nodes have the same value.

### Example

- Input:  
  \`p = [1,2,3]\`,  
  \`q = [1,2,3]\`  
  → Output: \`true\`

## Constraints

- The number of nodes in both trees is in the range \`[0, 100]\`
- \`-10^4 <= Node.val <= 10^4\``,
  },
  {
    id: 'search-in-a-binary-search-tree',
    title: 'Search in a Binary Search Tree',
    difficulty: 'Easy',
    topics: ["Tree","BST"],
    language: 'Java',
    description: 'Search for a value in a BST.',
    leetcodeUrl: 'https://leetcode.com/problems/search-in-a-binary-search-tree/',
    solution: `/**
 * Definition for a binary tree node.
 * public class TreeNode {
 *     int val;
 *     TreeNode left;
 *     TreeNode right;
 *     TreeNode() {}
 *     TreeNode(int val) { this.val = val; }
 *     TreeNode(int val, TreeNode left, TreeNode right) {
 *         this.val = val;
 *         this.left = left;
 *         this.right = right;
 *     }
 * }
 */
class Solution {
    public TreeNode searchBST(TreeNode root, int val) {
        if (root == null) return null;
        if (root.val == val) return root;
        if (val < root.val) return searchBST(root.left, val);
        return searchBST(root.right, val);
    }
}`,
    fullDescription: `## Description

You are given the \`root\` of a binary search tree (BST) and an integer \`val\`.  
Find the node in the BST whose value equals \`val\`, and return the subtree rooted with that node.  
If such a node does not exist, return \`null\`.

---

## Constraints

- The number of nodes in the tree is in the range \`[1, 5000]\`  
- \`1 <= Node.val <= 10⁷\`  
- \`root\` is a binary search tree  
- \`1 <= val <= 10⁷\``,
  },
  {
    id: 'second-highest-salary',
    title: 'Second Highest Salary',
    difficulty: 'Easy',
    topics: ["SQL"],
    language: 'SQL',
    description: 'Find the second highest salary from an Employee table.',
    leetcodeUrl: 'https://leetcode.com/problems/second-highest-salary/',
    solution: `SELECT 
  (SELECT DISTINCT salary 
   FROM Employee 
   ORDER BY salary DESC 
   LIMIT 1 OFFSET 1) AS SecondHighestSalary;`,
    fullDescription: `## Description

Write a solution to find the second highest distinct salary from the Employee table.  
If there is no second highest salary, return \`null\` (return \`None\` in Pandas).  
The result format is in the following example.

---

## Constraints

Table: Employee  
+-------------+------+  
| Column Name | Type |  
+-------------+------+  
| id          | int  |  
| salary      | int  |  
+-------------+------+  

- \`id\` is the primary key (column with unique values) for this table.  
- Each row of this table contains information about the salary of an employee.`,
  },
  {
    id: 'two-sum',
    title: 'Two Sum',
    difficulty: 'Easy',
    topics: ["Array","Hash Table"],
    language: 'JavaScript',
    description: 'Find two numbers that add up to a target value.',
    leetcodeUrl: 'https://leetcode.com/problems/two-sum/',
    solution: `var twoSum = function (nums, target) {
    const map = new Map();
    for (let i = 0; i < nums.length; i++) {
        const complement = target - nums[i];
        if (map.has(complement)) {
            return [map.get(complement), i];
        }
        map.set(nums[i], i);
    }
    return [];
};`,
    fullDescription: `## Description
Given an array of integers \`nums\` and an integer \`target\`, return **indices of the two numbers** such that they add up to \`target\`.

You may assume that each input would have **exactly one solution**, and you **may not use the same element twice**.

You can return the answer in **any order**.


## Follow-up
Can you come up with an algorithm that is **less than O(n²)** time complexity?`,
  },
  {
    id: 'two-sum-ii-input-array-is-sorted',
    title: 'Two Sum II - Input Array Is Sorted',
    difficulty: 'Easy',
    topics: ["Two Pointers","Array"],
    language: 'JavaScript',
    description: 'Find two numbers in a sorted array that add up to a target value.',
    leetcodeUrl: 'https://leetcode.com/problems/two-sum-ii-input-array-is-sorted/',
    solution: `/**
 * @param {number[]} numbers
 * @param {number} target
 * @return {number[]}
 */
var twoSum = function(numbers, target) {
    let left = 0, right = numbers.length - 1;
    while (left < right) {
        const sum = numbers[left] + numbers[right];
        if (sum === target) {
            return [left+1, right+1];
        } else if (sum > target) {
            right--;
        } else if (sum < target) {
            left++;
        }
    }
};`,
    fullDescription: `## Description

Given a sorted array of integers \`numbers\` and a target integer \`target\`, return the indices of the two numbers such that they add up to \`target\`.  
The solution must use constant extra space and the indices returned must be 1-based.

### Example

- Input: \`numbers = [2,7,11,15]\`, \`target = 9\` → Output: \`[1,2]\`  
  (Because \`numbers[0] + numbers[1] == 9\`)

## Constraints

- \`2 <= numbers.length <= 10^5\`
- \`-10^9 <= numbers[i] <= 10^9\`
- \`numbers\` is sorted in non-decreasing order
- Exactly one solution exists`,
  },
  {
    id: 'unique-number-of-occurrences',
    title: 'Unique Number of Occurrences',
    difficulty: 'Easy',
    topics: ["Array","Hash Table"],
    language: 'JavaScript',
    description: 'Check if the number of occurrences of each value is unique.',
    leetcodeUrl: 'https://leetcode.com/problems/unique-number-of-occurrences/',
    solution: `/**
 * @param {number[]} arr
 * @return {boolean}
 */
var uniqueOccurrences = function(arr) {
    const obj = {};
    for (const value of arr) {
        if (!obj[value]) {
            obj[value] = 0;
        }
        obj[value]++;
    }
    const objValues = Object.values(obj);
    return new Set(objValues)?.size === objValues.length
};`,
    fullDescription: `## Description

Given an array of integers \`arr\`, return \`true\` if the number of occurrences of each value in the array is unique or \`false\` otherwise.

---

## Constraints

- \`1 <= arr.length <= 1000\`  
- \`-1000 <= arr[i] <= 1000\``,
  },

  // ── MEDIUM ────────────────────────────────────────────────────────────────
  {
    id: 'cache-with-time-limit',
    title: 'Cache With Time Limit',
    difficulty: 'Medium',
    topics: ["Design","Hash Table"],
    language: 'JavaScript',
    description: 'Implement a cache that expires entries after a given time.',
    leetcodeUrl: 'https://leetcode.com/problems/cache-with-time-limit/',
    solution: `var TimeLimitedCache = function() {
    this.state = {}
};

/** 
 * @param {number} key
 * @param {number} value
 * @param {number} duration time until expiration in ms
 * @return {boolean} if un-expired key already existed
 */
TimeLimitedCache.prototype.set = function(key, value, duration) {
    const alreadyAccessible = this.get(key);
    this.state[key] = {value, expiration: new Date().getTime() + duration};
    return alreadyAccessible !== -1
};

/** 
 * @param {number} key
 * @return {number} value associated with key
 */
TimeLimitedCache.prototype.get = function(key) {
    if (!this.state[key] || this.getIfExpired(key)) {
        return -1
    }
    return this.state[key].value;
};

/** 
 * @return {number} count of non-expired keys
 */
TimeLimitedCache.prototype.count = function() {
    return Object.keys(this.state)?.filter(key => !this.getIfExpired(key))?.length || 0
};

TimeLimitedCache.prototype.getIfExpired = function(key) {
    return new Date().getTime() > this.state[key].expiration;
}
/**
 * const timeLimitedCache = new TimeLimitedCache()
 * timeLimitedCache.set(1, 42, 1000); // false
 * timeLimitedCache.get(1) // 42
 * timeLimitedCache.count() // 1
 */`,
    fullDescription: `## Description

Write a class that allows getting and setting key-value pairs, however a time until expiration is associated with each key.

The class has three public methods:

- \`set(key, value, duration)\`: accepts an integer \`key\`, an integer \`value\`, and a duration in milliseconds. Once the duration has elapsed, the key should be inaccessible. The method should return \`true\` if the same un-expired key already exists and \`false\` otherwise. Both the value and duration should be overwritten if the key already exists.

- \`get(key)\`: if an un-expired key exists, it should return the associated value. Otherwise it should return \`-1\`.

- \`count()\`: returns the count of un-expired keys.

---

## Constraints

- \`0 <= key, value <= 10⁹\`  
- \`0 <= duration <= 1000\`  
- \`1 <= actions.length <= 100\`  
- \`actions.length === values.length\`  
- \`actions.length === timeDelays.length\`  
- \`0 <= timeDelays[i] <= 1450\`  
- \`actions[i]\` is one of \`"TimeLimitedCache"\`, \`"set"\`, \`"get"\` and \`"count"\`  
- First action is always \`"TimeLimitedCache"\` and must be executed immediately, with a 0-millisecond delay`,
  },
  {
    id: 'delete-the-middle-node-of-a-linked-list',
    title: 'Delete the Middle Node of a Linked List',
    difficulty: 'Medium',
    topics: ["Linked List","Two Pointers"],
    language: 'Java',
    description: 'Remove the middle node from a linked list.',
    leetcodeUrl: 'https://leetcode.com/problems/delete-the-middle-node-of-a-linked-list/',
    solution: `/**
 * Definition for singly-linked list.
 * public class ListNode {
 *     int val;
 *     ListNode next;
 *     ListNode() {}
 *     ListNode(int val) { this.val = val; }
 *     ListNode(int val, ListNode next) { this.val = val; this.next = next; }
 * }
 */
class Solution {
    public ListNode deleteMiddle(ListNode head) {
        if (head.next == null) {
            return null;
        }
        ListNode prev = null, slow = head, fast = head;
        while (fast != null && fast.next != null) {
            prev = slow;
            slow = slow.next;
            fast = fast.next.next;
        }
        prev.next = slow.next;
        return head;
    }
}`,
    fullDescription: `## Description

You are given the \`head\` of a linked list.  
Delete the middle node, and return the head of the modified linked list.

The middle node of a linked list of size \`n\` is the ⌊n / 2⌋th node from the start using 0-based indexing, where ⌊x⌋ denotes the largest integer less than or equal to \`x\`.

---

## Constraints

- The number of nodes in the list is in the range \`[1, 10⁵]\`  
- \`1 <= Node.val <= 10⁵\``,
  },
  {
    id: 'determine-if-two-strings-are-close',
    title: 'Determine if Two Strings Are Close',
    difficulty: 'Medium',
    topics: ["Hash Table","String"],
    language: 'JavaScript',
    description: 'Check if two strings are close based on allowed operations.',
    leetcodeUrl: 'https://leetcode.com/problems/determine-if-two-strings-are-close/',
    solution: `/**
 * @param {string} word1
 * @param {string} word2
 * @return {boolean}
 */
var closeStrings = function(word1, word2) {
    if (word1.length !== word2.length) {
        return false;
    }
    const word1Obj = {};
    const word2Obj = {};
    for (let i = 0; i<word1.length; i++) {
        if (!word1Obj[word1[i]]) {
            word1Obj[word1[i]] = 0;
        }
        word1Obj[word1[i]]++;
        if (!word2Obj[word2[i]]) {
            word2Obj[word2[i]] = 0;
        }
        word2Obj[word2[i]]++;
    }
    const entries1 = Object.entries(word1Obj);
    const entries2 = Object.entries(word2Obj);
    if (entries1.length !== entries2.length) {
        return false;
    }
    for (let i = 0; i < entries1.length; i++) {
        if (!word2Obj[entries1[i][0]]) {
            return false;
        }
        if (!word1Obj[entries1[i][1]]) {
            word1Obj[entries1[i][1]] = 0;
        }
        word1Obj[entries1[i][1]]++
        if (!word2Obj[entries2[i][1]]) {
            word2Obj[entries2[i][1]] = 0;
        }
        word2Obj[entries2[i][1]]++
        
    }
    for (let i = 0; i < entries1.length; i++) {
        if (word2Obj[entries1[i][1]] !== word1Obj[entries1[i][1]]) {
            return false;
        }
    }
    return true
};`,
    fullDescription: `## Description

Two strings are considered close if you can attain one from the other using the following operations:

- Operation 1: Swap any two existing characters.  
- Operation 2: Transform every occurrence of one existing character into another existing character, and do the same with the other character.

You can use the operations on either string as many times as necessary.

Given two strings \`word1\` and \`word2\`, return \`true\` if \`word1\` and \`word2\` are close, and \`false\` otherwise.

---

## Constraints

- \`1 <= word1.length, word2.length <= 10⁵\`  
- \`word1\` and \`word2\` contain only lowercase English letters.`,
  },
  {
    id: 'equal-row-and-column-pairs',
    title: 'Equal Row and Column Pairs',
    difficulty: 'Medium',
    topics: ["Array","Hash Table"],
    language: 'JavaScript',
    description: 'Count pairs where a row equals a column in a grid.',
    leetcodeUrl: 'https://leetcode.com/problems/equal-row-and-column-pairs/',
    solution: `/**
 * @param {number[][]} grid
 * @return {number}
 */
var equalPairs = function(grid) {
    const rows = new Map();
    const columns = new Map();
    let colKey = "", rowKey = "";
    for (let i = 0; i<grid.length; i++) {
        for (let j = 0; j<grid[i].length; j++) {
            colKey = colKey + grid[j][i] + "_";
            if (j === grid.length - 1) {
                columns.set(colKey, (columns.get(colKey) || 0) + 1);
                colKey = "";
            }
            rowKey = rowKey + grid[i][j] + "_";
            if (j === grid.length - 1) {
                rows.set(rowKey, (rows.get(rowKey) || 0) + 1);
                rowKey = "";
            }
        }
    }
    let counter = 0;
    Object.keys(columns).forEach(k => {
        if (rows[k]) {
            counter += rows[k] * columns[k];
        }
    })
    return counter
};`,
    fullDescription: `## Description

Given a 0-indexed \`n x n\` integer matrix \`grid\`, return the number of pairs \`(ri, cj)\` such that row \`ri\` and column \`cj\` are equal.

A row and column pair is considered equal if they contain the same elements in the same order (i.e., they form an equal array).

---

## Constraints

- \`n == grid.length == grid[i].length\`  
- \`1 <= n <= 200\`  
- \`1 <= grid[i][j] <= 10⁵\``,
  },
  {
    id: 'find-the-difference-of-two-arrays',
    title: 'Find the Difference of Two Arrays',
    difficulty: 'Medium',
    topics: ["Hash Table"],
    language: 'JavaScript',
    description: 'Return the distinct elements between two arrays.',
    leetcodeUrl: 'https://leetcode.com/problems/find-the-difference-of-two-arrays/',
    solution: `/**
 * @param {number[]} nums1
 * @param {number[]} nums2
 * @return {number[][]}
 */
var findDifference = function(nums1, nums2) {
    const set1 = new Set(nums1);
    const set2 = new Set(nums2);
    return [Array.from(set1).filter(n => !set2.has(n)), Array.from(set2).filter(n => !set1.has(n))]
};`,
    fullDescription: `## Description

Given two 0-indexed integer arrays \`nums1\` and \`nums2\`, return a list \`answer\` of size 2 where:

- \`answer[0]\` is a list of all distinct integers in \`nums1\` which are not present in \`nums2\`.
- \`answer[1]\` is a list of all distinct integers in \`nums2\` which are not present in \`nums1\`.

Note that the integers in the lists may be returned in any order.

---

## Constraints

- \`1 <= nums1.length, nums2.length <= 1000\`  
- \`-1000 <= nums1[i], nums2[i] <= 1000\``,
  },
  {
    id: 'increasing-triplet-subsequence',
    title: 'Increasing Triplet Subsequence',
    difficulty: 'Medium',
    topics: ["Array","Greedy"],
    language: 'JavaScript',
    description: 'Check if there exists a triplet with increasing values.',
    leetcodeUrl: 'https://leetcode.com/problems/increasing-triplet-subsequence/',
    solution: `/**
 * @param {number[]} nums
 * @return {boolean}
 */
var increasingTriplet = function(nums) {
    let lowest = Infinity;
    let secondLowest = Infinity;
    for (let num of nums) {
        if (num <= lowest) {
            lowest = num;
        } else if (num <= secondLowest) {
            secondLowest = num;
        } else if (lowest < secondLowest && secondLowest < num) {
            return true;
        }
    }
    return false;
};`,
    fullDescription: `## Description

Given an integer array \`nums\`, return \`true\` if there exists a triple of indices \`(i, j, k)\` such that \`i < j < k\` and \`nums[i] < nums[j] < nums[k]\`.  
If no such indices exist, return \`false\`.

---

## Constraints

- \`1 <= nums.length <= 5 * 10⁵\`  
- \`-2³¹ <= nums[i] <= 2³¹ - 1\`

---

## Follow-up

Could you implement a solution that runs in \`O(n)\` time complexity and \`O(1)\` space complexity?`,
  },
  {
    id: 'leaf-similar-trees',
    title: 'Leaf-Similar Trees',
    difficulty: 'Medium',
    topics: ["Tree","DFS"],
    language: 'Java',
    description: 'Check if two trees have the same leaf sequence.',
    leetcodeUrl: 'https://leetcode.com/problems/leaf-similar-trees/',
    solution: `/**
 * Definition for a binary tree node.
 * public class TreeNode {
 *     int val;
 *     TreeNode left;
 *     TreeNode right;
 *     TreeNode() {}
 *     TreeNode(int val) { this.val = val; }
 *     TreeNode(int val, TreeNode left, TreeNode right) {
 *         this.val = val;
 *         this.left = left;
 *         this.right = right;
 *     }
 * }
 */
class Solution {
    List<Integer> list1 = new ArrayList<>();
    List<Integer> list2 = new ArrayList<>();
    
    public boolean leafSimilar(TreeNode root1, TreeNode root2) {
        createLeafList(root1, list1);
        createLeafList(root2, list2);
        if (list1.size() != list2.size()) {
            return false;
        }
        for (int i = 0; i<list1.size(); i++) {
            if (!list1.get(i).equals(list2.get(i))) {
                return false;
            }
        }
        return true;
    }

    public void createLeafList(TreeNode root, List<Integer> list) {
        if (root == null) {
            return;
        }
        if (root.left == null && root.right == null) {
            list.add(root.val);
        }
        createLeafList(root.left, list);
        createLeafList(root.right, list);
    }
}`,
    fullDescription: `## Description

Consider all the leaves of a binary tree in left-to-right order. The values of these leaves form a leaf value sequence.

Two binary trees are considered **leaf-similar** if their leaf value sequences are the same.

Given two binary trees with root nodes \`root1\` and \`root2\`, return \`true\` if they are leaf-similar, and \`false\` otherwise.

---

## Constraints

- The number of nodes in each tree is in the range \`[1, 200]\`  
- Each tree node's value is in the range \`[0, 200]\``,
  },
  {
    id: 'longest-subarray-of1s-after-deleting-one-element',
    title: 'Longest Subarray of 1\'s After Deleting One Element',
    difficulty: 'Medium',
    topics: ["Array","Sliding Window"],
    language: 'JavaScript',
    description: 'Find the longest subarray of 1\'s after deleting one element.',
    leetcodeUrl: 'https://leetcode.com/problems/longest-subarray-of-1s-after-deleting-one-element/',
    solution: `/**
 * @param {number[]} nums
 * @return {number}
 */
var longestSubarray = function(nums) {
    let max = 0;
    let k = 0;
    let zeroInWindow = 0;
    let moreThanOneZero = false;
    let zeroIndex = 0;
    for (let i = 0; i< nums.length; i++) {
        if (nums[i] === 1) {
            const currentOnes = i-k;
            if (currentOnes > max) {
                max = currentOnes;
            }
        }
        if (nums[i] === 0) {
            zeroInWindow++;
            const currentOnes = i-k-1;
            if (currentOnes > max) {
                max = currentOnes;
            }
            if (zeroInWindow > 1) {
                moreThanOneZero = true;
                k = zeroIndex + 1;
                zeroInWindow--;
            }
            zeroIndex = i;
        }
    }
    if (!moreThanOneZero) {
        return nums.length - 1;
    }
    return max;
};`,
    fullDescription: `## Description

Given a binary array \`nums\`, you should delete one element from it.  
Return the size of the longest non-empty subarray containing only \`1\`s in the resulting array.  
Return \`0\` if there is no such subarray.

---

## Constraints

- \`1 <= nums.length <= 10⁵\`  
- \`nums[i]\` is either \`0\` or \`1\``,
  },
  {
    id: 'max-number-of-k-sum-pairs',
    title: 'Max Number of K-Sum Pairs',
    difficulty: 'Medium',
    topics: ["Array","Hash Table"],
    language: 'JavaScript',
    description: 'Find the maximum number of pairs that sum to k.',
    leetcodeUrl: 'https://leetcode.com/problems/max-number-of-k-sum-pairs/',
    solution: `/**
 * @param {number[]} nums
 * @param {number} k
 * @return {number}
 */
var maxOperations = function(nums, k) {
    const map = new Map();
    let counter = 0;
    for (let i = 0; i < nums.length; i++) {
        const num = nums[i];
        const complement = k-num;
        if (map.has(num)) {
            counter++;
            const value = map.get(num);
            if (value === 1) {
                map.delete(num);
            } else {
                map.set(num, value-1);
            }
        } else if (complement > 0) {
            if (!map.has(complement)) {
                map.set(complement, 0)
            }
            map.set(complement, map.get(complement) + 1);
        }

    }
    return counter;
};`,
    fullDescription: `## Description

Given an array of integers \`nums\` and an integer \`k\`, return the maximum number of operations you can perform where each operation consists of removing two numbers whose sum equals \`k\`.  
Each element in the array can be used at most once.

### Example

- Input: \`nums = [1,2,3,4]\`, \`k = 5\` → Output: \`2\`  
  (Valid pairs: [1,4] and [2,3])

## Constraints

- \`1 <= nums.length <= 10^5\`
- \`1 <= nums[i] <= 10^9\`
- \`1 <= k <= 10^9\``,
  },
  {
    id: 'maximum-number-of-vowels-in-a-substring-of-given-length',
    title: 'Maximum Number of Vowels in a Substring of Given Length',
    difficulty: 'Medium',
    topics: ["String","Sliding Window"],
    language: 'JavaScript',
    description: 'Find the max number of vowels in a fixed-length substring.',
    leetcodeUrl: 'https://leetcode.com/problems/maximum-number-of-vowels-in-a-substring-of-given-length/',
    solution: `/**
 * @param {string} s
 * @param {number} k
 * @return {number}
 */
var maxVowels = function(s, k) {
    let currentVowels = 0;
    for (let i = 0; i<k; i++) {
        if (vowels[s[i]]) {
            currentVowels++;
        }
    }

    if (currentVowels === k) {
        return k;
    }
    let maxVowels = currentVowels;
    for (let i = k; i < s.length; i++) {
        if (vowels[s[i-k]]) {
            currentVowels--;
        }
        if (vowels[s[i]]) {
            currentVowels++;
        }
        if (currentVowels > maxVowels) {
            maxVowels = currentVowels;
        }
    }

    return maxVowels
};

const vowels = {'a': true,'e': true,'i': true,'o': true,'u': true}`,
    fullDescription: `## Description

Given a string \`s\` and an integer \`k\`, return the maximum number of vowel letters in any substring of \`s\` with length \`k\`.

Vowel letters in English are \`'a'\`, \`'e'\`, \`'i'\`, \`'o'\`, and \`'u'\`.

---

## Constraints

- \`1 <= s.length <= 10⁵\`  
- \`s\` consists of lowercase English letters  
- \`1 <= k <= s.length\``,
  },
  {
    id: 'merge-strings-alternately',
    title: 'Merge Strings Alternately',
    difficulty: 'Medium',
    topics: ["Two Pointers","String"],
    language: 'JavaScript',
    description: 'Merge two strings by alternating characters.',
    leetcodeUrl: 'https://leetcode.com/problems/merge-strings-alternately/',
    solution: `/**
 * @param {string} word1
 * @param {string} word2
 * @return {string}
 */
var mergeAlternately = function(word1, word2) {
    const word1Arr = word1.split("");
    const word2Arr = word2.split("");
    const resultWordArr = [];
    for (let i = 0; i < (word1Arr.length >= word2Arr.length ? word1Arr.length : word2Arr.length); i++) {
        if (word1Arr[i]) {
            resultWordArr.push(word1Arr[i]);
        }
        if (word2Arr[i]) {
            resultWordArr.push(word2Arr[i]);
        }
    }
    return resultWordArr.join('')
};`,
    fullDescription: `## Description

You are given two strings \`word1\` and \`word2\`.  
Merge the strings by adding letters in alternating order, starting with \`word1\`.  
If a string is longer than the other, append the additional letters onto the end of the merged string.

Return the merged string.

---

## Constraints

- \`1 <= word1.length, word2.length <= 100\`  
- \`word1\` and \`word2\` consist of lowercase English letters.`,
  },
  {
    id: 'move-zeroes',
    title: 'Move Zeroes',
    difficulty: 'Medium',
    topics: ["Array","Two Pointers"],
    language: 'JavaScript',
    description: 'Move all zeroes to the end while maintaining order.',
    leetcodeUrl: 'https://leetcode.com/problems/move-zeroes/',
    solution: `/**
 * @param {number[]} nums
 * @return {void} Do not return anything, modify nums in-place instead.
 */
var moveZeroes = function(nums) {
    let lastNonZeroFoundAt = 0;
    for (let i = 0; i<nums.length; i++) {
        if (nums[i] !== 0) {
            nums[lastNonZeroFoundAt] = nums[i] 
            if (i !== lastNonZeroFoundAt) {
                nums[i] = 0;
            }
            lastNonZeroFoundAt++
        }
        
    }
};`,
    fullDescription: `## Description

Given an integer array \`nums\`, move all \`0\`'s to the end of it while maintaining the relative order of the non-zero elements.

Note that you must do this in-place without making a copy of the array.

---

## Constraints

- \`1 <= nums.length <= 10⁴\`  
- \`-2³¹ <= nums[i] <= 2³¹ - 1\`

---

## Follow-up

Could you minimize the total number of operations done?`,
  },
  {
    id: 'product-of-array-except-self',
    title: 'Product of Array Except Self',
    difficulty: 'Medium',
    topics: ["Array","Prefix Product"],
    language: 'JavaScript',
    description: 'Return an array where each element is the product of all other elements.',
    leetcodeUrl: 'https://leetcode.com/problems/product-of-array-except-self/',
    solution: `/**
 * @param {number[]} nums
 * @return {number[]}
 */
var productExceptSelf = function(nums) {
    const n = nums.length;
    const result = Array(n).fill(1);
    for (let i = 1; i < n; i++) {
        result[i] = result[i - 1] * nums[i - 1];
    }
    let rightProduct = 1;
    for (let i = n - 1; i >= 0; i--) {
        result[i] *= rightProduct;
        rightProduct *= nums[i];
    }
    return result;
};`,
    fullDescription: `## Description

Given an integer array \`nums\`, return an array \`answer\` such that \`answer[i]\` is equal to the product of all the elements of \`nums\` except \`nums[i]\`.

The product of any prefix or suffix of \`nums\` is guaranteed to fit in a 32-bit integer.

You must write an algorithm that runs in \`O(n)\` time and without using the division operation.

---

## Constraints

- \`2 <= nums.length <= 10⁵\`  
- \`-30 <= nums[i] <= 30\`  
- The input is generated such that \`answer[i]\` is guaranteed to fit in a 32-bit integer.

---

## Follow-up

Can you solve the problem in \`O(1)\` extra space complexity?  
(The output array does not count as extra space for space complexity analysis.)`,
  },
  {
    id: 'removing-stars-from-a-string',
    title: 'Removing Stars From a String',
    difficulty: 'Medium',
    topics: ["String","Stack"],
    language: 'JavaScript',
    description: 'Remove stars and the closest non-star character to the left.',
    leetcodeUrl: 'https://leetcode.com/problems/removing-stars-from-a-string/',
    solution: `/**
 * @param {string} s
 * @return {string}
 */
var removeStars = function(s) {
    const arr = [];
    for (let i = 0; i<s.length; i++) {
        if (s[i] === "*") {
            arr.pop();
        } else {
            arr.push(s[i])
        }
    }
    return arr.join('');
};`,
    fullDescription: `## Description

You are given a string \`s\`, which contains stars \`*\`. In one operation, you can:

- Choose a star in \`s\`.
- Remove the closest non-star character to its left, as well as remove the star itself.

Return the string after all stars have been removed.

Note: The input will be generated such that the operation is always possible. It can be shown that the resulting string will always be unique.

---

## Constraints

- \`1 <= s.length <= 10⁵\`  
- \`s\` consists of lowercase English letters and stars \`*\`.  
- The operation above can be performed on \`s\`.`,
  },
  {
    id: 'reverse-degree-of-a-string',
    title: 'Reverse Degree of a String',
    difficulty: 'Medium',
    topics: ["String"],
    language: 'JavaScript',
    description: 'Reverse the degree/order of characters in a string.',
    leetcodeUrl: 'https://leetcode.com/problems/reverse-degree-of-a-string/',
    solution: `/**
 * @param {string} s
 * @return {number}
 */
var reverseDegree = function(s) {
    return s.split("").reduce((a,b,i) => a+(-1*(b.charCodeAt()-123)*(i+1)), 0)
};`,
    fullDescription: `## Description

Given a string \`s\`, calculate its reverse degree.

The reverse degree is calculated as follows:  
For each character, multiply its position in the reversed alphabet (\`'a' = 26\`, \`'b' = 25\`, ..., \`'z' = 1\`) with its position in the string (1-indexed).  
Sum these products for all characters in the string.  

Return the reverse degree of \`s\`.

---

## Constraints

- \`1 <= s.length <= 1000\`  
- \`s\` contains only lowercase English letters.`,
  },
  {
    id: 'string-compression',
    title: 'String Compression',
    difficulty: 'Medium',
    topics: ["Two Pointers","String"],
    language: 'JavaScript',
    description: 'Compress a string in-place.',
    leetcodeUrl: 'https://leetcode.com/problems/string-compression/',
    solution: `/**
 * @param {character[]} chars
 * @return {number}
 */
var compress = function(chars) {
    let writeIndex = 0;
    let counter = 0;
    if (chars.length === 1) {
        return 1;
    }
    for(let i = 0; i < chars.length; i++) {
        if (chars[i] === chars[i+1]) {
            counter++;
        } else {
            const numberArr = (counter + 1).toString().split('');
            chars[writeIndex] = chars[i];
            writeIndex++
            for (let digit of numberArr) {
                chars[writeIndex] = digit;
                writeIndex++;
            }
            counter = 0;
        }
    }
    chars.length = writeIndex;
    return chars.length;
};`,
    fullDescription: `## Description

Given an array of characters \`chars\`, compress it using the following algorithm:

Begin with an empty string \`s\`. For each group of consecutive repeating characters in \`chars\`:
- If the group's length is 1, append the character to \`s\`.
- Otherwise, append the character followed by the group's length.

The compressed string \`s\` should not be returned separately, but instead, be stored in the input character array \`chars\`.

Note that group lengths that are 10 or longer will be split into multiple characters in \`chars\`.

After you are done modifying the input array, return the new length of the array.

You must write an algorithm that uses only constant extra space.

---

## Constraints

- \`1 <= chars.length <= 2000\`  
- \`chars[i]\` is a lowercase English letter, uppercase English letter, digit, or symbol.`,
  },

  // ── HARD ──────────────────────────────────────────────────────────────────
  {
    id: 'median-of-two-sorted-arrays',
    title: 'Median of Two Sorted Arrays',
    difficulty: 'Hard',
    topics: ["Array","Binary Search","Divide and Conquer"],
    language: 'JavaScript',
    description: 'Find the median of two sorted arrays in logarithmic time.',
    leetcodeUrl: 'https://leetcode.com/problems/median-of-two-sorted-arrays/',
    solution: `/**
 * @param {number[]} nums1
 * @param {number[]} nums2
 * @return {number}
 */
var findMedianSortedArrays = function(nums1, nums2) {
    const length1 = nums1.length, length2 = nums2.length;
    if (length1 === 0) {
        if (length2 % 2 === 0) {
            return (nums2[length2/2] + nums2[length2/2 - 1]) / 2;
        } else {
            return nums2[Math.floor(length2/2)];
        }
    }
    if (length2 === 0) {
        if (length1 % 2 === 0) {
            return (nums1[length1/2] + nums1[length1/2 - 1]) / 2;
        } else {
            return nums1[Math.floor(length1/2)];
        }
    }
    const lengthSum = length1 + length2;
    if (lengthSum % 2 === 0) {
        return (findMedian(nums1, nums2, lengthSum/2) + findMedian(nums1, nums2, lengthSum/2 + 1)) / 2
    }
    return findMedian(nums1, nums2, Math.floor(lengthSum / 2) + 1)
};

const findMedian = function(nums1, nums2, k) {
    const length1 = nums1.length, length2 = nums2.length;
    if (length1 === 0) {
        return nums2[k - 1]
    }
    if (length2 === 0) {
        return nums1[k - 1]
    }
    if (k === 1) {
        return Math.min(nums1[0], nums2[0]);
    }

    const num1K = Math.min(Math.floor(k / 2), length1);
    const num2K = Math.min(Math.floor(k / 2), length2);
    const num1 = nums1[num1K - 1];
    const num2 = nums2[num2K - 1];
    if (num1 < num2) {
        return (findMedian(nums1.slice(num1K), nums2, k - num1K));
    }
    return (findMedian(nums1, nums2.slice(num2K), k - num2K));
}`,
    fullDescription: `## Description

Given two sorted arrays \`nums1\` and \`nums2\` of size \`m\` and \`n\` respectively, return the median of the two sorted arrays.  
The overall run time complexity should be \`O(log (m+n))\`.

### Example

- Input: \`nums1 = [1, 3]\`, \`nums2 = [2]\` → Output: \`2.0\`  
- Input: \`nums1 = [1, 2]\`, \`nums2 = [3, 4]\` → Output: \`2.5\`

## Constraints

- \`nums1.length == m\`
- \`nums2.length == n\`
- \`0 <= m <= 1000\`
- \`0 <= n <= 1000\`
- \`1 <= m + n <= 2000\`
- \`-10^6 <= nums1[i], nums2[i] <= 10^6\``,
  },
];
